import * as FnolOnPropertyChangeConstants from "constants/FnolOnPropertyChangeConstants";
import * as fieldMappingConstants from "constants/FieldMappingConstants";
import { isNullOrEmpty } from "./Helpers";
import { FNOLCOMPONENT_MULTIOPTIONDROPDOWN } from "constants/FnolComponentConstants";

export class OnPropertyChangeResponse {
  constructor(response) {
    this.changes = [];
    this.affectedFields = [];

    for (const [fieldPath, value] of Object.entries(response)) {
      this.changes.push(new ChangeFieldDetails(fieldPath, value));
      this.affectedFields.push(fieldPath);
    }
  }
}

export class MultiDropdownOnPropertyChangeResponse {
  constructor(response) {
    this.changes = [];
    this.affectedFields = [];

    for (const [fieldPath, [value, triggerOption]] of Object.entries(response)) {
      this.changes.push(new MultiDropdownChangeFieldDetails(fieldPath, value, triggerOption));
      this.affectedFields.push(fieldPath);
    }
  }
}

export class ChangeFieldDetails {
  constructor(fieldPath, value) {
    this.fieldPath = fieldPath;
    this.value = value;
  }
}
export class MultiDropdownChangeFieldDetails extends ChangeFieldDetails {
  constructor(fieldPath, value, triggerOption) {
    super(fieldPath, value);
    this.triggerOption = triggerOption;
  }
}
export class TriggeredByDetails {
  constructor(fieldPath) {
    this.fieldPath = fieldPath;
  }
}

export class ChangeDetails {
  constructor(changeFieldDetails, changeTriggeredByDetails) {
    this.changeFieldDetails = changeFieldDetails;
    this.changeTriggeredByDetails = changeTriggeredByDetails;
    this.tpId =
      this.changeFieldDetails.fieldPath?.split(":")?.slice(0, 1)[0] === fieldMappingConstants.ThirdParties
        ? this.changeFieldDetails.fieldPath?.split(":")?.slice(1, 2)[0] ?? null
        : null;
    this.tpField = this.tpId ? this.changeFieldDetails.fieldPath?.split(":")?.slice(-1)[0] ?? null : null;
  }

  clone() {
    const changeFieldDetailsClone = new ChangeFieldDetails(
      this.changeFieldDetails.fieldPath,
      this.changeFieldDetails.value
    );
    const triggeredBydetailsClone = new TriggeredByDetails(this.changeTriggeredByDetails.fieldPath);
    return new ChangeDetails(changeFieldDetailsClone, triggeredBydetailsClone);
  }

  shouldFieldBeResetByThisChange(lastChangeTriggeredByDetails) {
    return this.changeTriggeredByDetails.fieldPath === lastChangeTriggeredByDetails.fieldPath;
  }

  doesChangeAssignField(fieldPath) {
    return this.changeFieldDetails.fieldPath === fieldPath && !isNullOrEmpty(this.changeFieldDetails.value);
  }

  doesChangeAssignFieldInTP(tpId) {
    return this.tpId === tpId && !isNullOrEmpty(this.changeFieldDetails.value);
  }

  generateResetChangeForField(fieldPath) {
    return new ChangeDetails(
      new ChangeFieldDetails(fieldPath, FnolOnPropertyChangeConstants.ResetCode),
      new TriggeredByDetails(this.changeTriggeredByDetails.fieldPath)
    );
  }
}

export class TPOnPropertyChangeToTrigger {
  constructor(tpField, params) {
    this.tpField = tpField;
    this.params = params;
  }
}

export class MultiDropdownChangeTracker {
  constructor(currentOptionArray, newOptionArray) {
    this.currentOptionArray = [...currentOptionArray];
    this.newOptionArray = [...newOptionArray];
    this.addedValues = [];
    this.removedValues = [];
    this.getDiff();
  }

  getDiff() {
    const currentValues = this.currentOptionArray.map((opt) => opt.value);
    const newValues = this.newOptionArray.map((opt) => opt.value);
    this.addedValues = this.newOptionArray.filter((opt) => !currentValues.includes(opt.value));
    this.removedValues = this.currentOptionArray.filter((opt) => !newValues.includes(opt.value));
  }
}

export const generateAutoPopulatedByStringForMultiDropdownField = (fieldPath, populatedOption) => {
  return `${fieldPath}%(${populatedOption})%`;
};

export class FieldPath {
  constructor(topLevelFieldMapping, subLevelUID = null) {
    this.levelUIDs = [[topLevelFieldMapping, subLevelUID]];
  }

  addlevel(levelFieldMapping, subLevelUID = null) {
    this.levelUIDs.push([levelFieldMapping, subLevelUID]);
    return this;
  }

  generateFieldPathString() {
    let fieldPath = "";
    for (const levelId of this.levelUIDs) {
      if (fieldPath.length === 0) {
        fieldPath = fieldPath.concat(`${levelId[0]}`);
        if (levelId[1] !== null) {
          fieldPath = fieldPath.concat(`:${levelId[1]}`);
        }
      } else {
        fieldPath = fieldPath.concat(`:${levelId[0]}`);
        if (levelId[1] !== null) {
          fieldPath = fieldPath.concat(`:${levelId[1]}`);
        }
      }
    }
    return fieldPath;
  }
}

export const generateOnPropertyChangeParameters = (fnolComponent, fnolInstance, previousValue) => {
  const fieldIndex = fnolInstance.fnolValues?.findIndex((field) => field.fieldMapping === fnolComponent.fieldMapping);

  switch (fnolComponent.controlType) {
    case FNOLCOMPONENT_MULTIOPTIONDROPDOWN:
      const fnolValuesClone = [...fnolInstance.fnolValues];
      const instanceClone = { ...fnolInstance };

      const changes = new MultiDropdownChangeTracker(
        previousValue ?? [],
        fnolInstance.fnolValues[fieldIndex]?.value ?? []
      );

      if (fieldIndex !== undefined && fieldIndex !== -1) {
        const fnolValue = { ...fnolValuesClone[fieldIndex] };
        fnolValue.value = changes.addedValues;
        fnolValuesClone[fieldIndex] = fnolValue;
        instanceClone.fnolValues = fnolValuesClone;
      }

      return [
        new FieldPath(fnolComponent.fieldMapping).generateFieldPathString(),
        instanceClone,
        {
          removedOptions: changes.removedValues,
          controlType: FNOLCOMPONENT_MULTIOPTIONDROPDOWN,
        },
      ];
    default:
      return [new FieldPath(fnolComponent.fieldMapping).generateFieldPathString(), fnolInstance];
  }
};
